import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "feature-toggle",
        { attrs: { toggle: _vm.selectCompetitorsOnExport } },
        [
          _c("select-competitors-download-dialog", {
            attrs: { "is-open": _vm.isSelectCompetitorsDialogOpen },
            on: {
              closeSelectCompetitorDialog: function ($event) {
                _vm.isSelectCompetitorsDialogOpen = false
              },
              downloadData: function ($event) {
                return _vm.downloadDataWithSelection($event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VRow,
        {
          staticClass: "mb-2 controls-row",
          attrs: { justify: "start", align: "center" },
        },
        [
          _c(
            VCol,
            { staticClass: "ml-4 pr-2", attrs: { cols: "2" } },
            [
              _c(VTextField, {
                staticClass: "inputs-actions__search",
                attrs: {
                  flat: "",
                  dense: "",
                  "hide-details": "",
                  disabled: _vm.itemsNotReadyForDisplay,
                  label: _vm.$t("actions.search"),
                  "single-line": "",
                  "append-icon": "mdi-magnify",
                },
                on: { input: _vm.debouncedFilterChange },
                model: {
                  value: _vm.searchString,
                  callback: function ($$v) {
                    _vm.searchString = $$v
                  },
                  expression: "searchString",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-center mx-1" },
            [
              _c("norm-weight-toggle", {
                staticClass: "norm-weight-toggle",
                on: {
                  change: function ($event) {
                    return _vm.updateColumnDefsPreservingSort(
                      _vm.storegroupKeyNameMap
                    )
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isUnitManagerView
            ? _c(
                VCol,
                { staticClass: "pr-2", attrs: { cols: "2" } },
                [
                  _c("scenario-filter", {
                    attrs: {
                      "hide-pricing-group-selection": true,
                      dense: false,
                      solo: false,
                      "hide-label": true,
                    },
                    on: { selectScenario: _vm.selectScenario },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isUnitManagerView
            ? _c(VDivider, {
                staticClass: "controls-row__divider",
                attrs: { vertical: "" },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            VCol,
            { staticClass: "d-flex align-center engine-controls-col" },
            [
              !_vm.isUnitManagerView
                ? _c("engine-controls", {
                    attrs: {
                      "level-entry-key": _vm.levelEntryKey,
                      "pricing-group-name": _vm.pricingGroupName,
                      "show-tool-store-group": _vm.isGroupTSGsEnabled,
                      items: _vm.filteredItems,
                    },
                    on: { "bulk-action-selected": _vm.handleBulkAction },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VCol,
            {
              staticClass: "d-flex align-center pr-2 filter-col",
              attrs: { cols: "auto" },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex align-center filter-buttons-container" },
                [
                  _c("span", { staticClass: "filter-by-text mr-2" }, [
                    _vm._v("Filter by:"),
                  ]),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      staticClass: "columns-toggle grid-btn pa-0 mr-2",
                      attrs: { secondary: "", small: "", depressed: "" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleSideBar("columns")
                        },
                      },
                    },
                    [
                      _c(VIcon, { staticClass: "mr-1" }, [
                        _vm._v("mdi-view-column-outline"),
                      ]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("inputs.columns")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      staticClass: "layouts-toggle grid-btn pa-0",
                      attrs: { secondary: "", small: "", depressed: "" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleSideBar("layouts")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("grid.layouts.button")) +
                          "\n          "
                      ),
                      _c(
                        VIcon,
                        {
                          staticClass:
                            "material-icons-outlined ml-1 sidebar-toggle",
                        },
                        [
                          _vm._v(
                            "\n            mdi-view-dashboard-outline\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.noLayoutsExist
        ? _c(
            VAlert,
            { staticClass: "mx-4 mt-2", attrs: { type: "info", text: "" } },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("grid.layouts.sidebar.noLayouts")) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid-view-ag-grid-content" },
        [
          _c("ag-grid-vue", {
            staticClass: "ag-theme-custom ag-product-list-grid",
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              loading: _vm.itemsNotReadyForDisplay,
              "default-col-def": _vm.defaultColDef,
              "row-data": _vm.itemsNotReadyForDisplay ? null : _vm.rowData,
              "side-bar": _vm.sideBar,
              "fill-operation": _vm.fillOperation,
            },
            on: {
              "grid-ready": _vm.onGridReady,
              "column-visible": _vm.onColumnVisible,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VLayout,
        { attrs: { row: "", "justify-center": "" } },
        [
          _c(
            VDialog,
            {
              on: {
                "click:outside": _vm.closeDialog,
                input: (dialogVisible) => !dialogVisible && _vm.closeDialog(),
              },
              model: {
                value: _vm.isProductDialogOpen,
                callback: function ($$v) {
                  _vm.isProductDialogOpen = $$v
                },
                expression: "isProductDialogOpen",
              },
            },
            [
              _vm.selectedProduct
                ? _c(
                    VCard,
                    [
                      _vm.expandedProduct
                        ? _c(VCardTitle, { staticClass: "headline" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.expandedProduct.article.productKeyDisplay
                                ) +
                                " -\n          " +
                                _vm._s(
                                  _vm.expandedProduct.article.productDescription
                                ) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        VIcon,
                        {
                          staticClass: "close-button",
                          attrs: { color: "grey" },
                          on: { click: _vm.closeDialog },
                        },
                        [_vm._v("\n          close\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        VCardText,
                        { staticClass: "product-dialog-content" },
                        [
                          _c("expanded-product-view", {
                            key: `product-${_vm.selectedProduct.productKey}-${_vm.selectedProduct.toolStoreGroupKey}`,
                            attrs: {
                              product: _vm.selectedProduct,
                              "is-unit-manager-view": _vm.isUnitManagerView,
                            },
                            on: {
                              toggleFilteringByArchitectureGroup:
                                _vm.onToggleFilteringByArchitectureGroup,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        VCardActions,
                        [
                          _c(VSpacer),
                          _vm._v(" "),
                          _c(
                            VBtn,
                            {
                              staticClass: "primary close-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.closeDialog()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("actions.close")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("confirm-dialog", {
        attrs: {
          "is-open": _vm.isBulkConfirmDialogOpen,
          "ok-btn-text": _vm.$t("actions.confirm"),
          "cancel-btn-text": _vm.$t("actions.cancel"),
        },
        on: { onOk: _vm.executeBulkOverride, onCancel: _vm.cancelBulkOverride },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("div", [
                  _c("p", [_vm._v(_vm._s(_vm.bulkConfirmData.actionLabel))]),
                  _vm._v(" "),
                  _vm.bulkConfirmData.isRemove &&
                  _vm.bulkConfirmData.blocked > 0
                    ? _c("p", { staticClass: "warning-text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "gridView.bulkActions.confirmRemoveWithSkipped",
                                {
                                  skipped: _vm.bulkConfirmData.blocked,
                                  eligible: _vm.bulkConfirmData.eligible,
                                }
                              )
                            ) +
                            "\n        "
                        ),
                      ])
                    : !_vm.bulkConfirmData.isRemove &&
                      _vm.bulkConfirmData.blocked > 0
                    ? _c("p", { staticClass: "warning-text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "gridView.bulkActions.confirmWithBlocked",
                                {
                                  blocked: _vm.bulkConfirmData.blocked,
                                  eligible: _vm.bulkConfirmData.eligible,
                                }
                              )
                            ) +
                            "\n        "
                        ),
                      ])
                    : _c("p", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("gridView.bulkActions.confirmMessage", {
                                count: _vm.bulkConfirmData.total,
                              })
                            ) +
                            "\n        "
                        ),
                      ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }